module.exports = __webpack_public_path__ + "img/tran1.9d8c75d2.png";